module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/26a4170c481d21b71495a42ccf1b491e.png";